var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dialog-add-note" },
    [
      !_vm.editText
        ? _c("el-input", {
            attrs: {
              type: "textarea",
              rows: 10,
              maxlength: "1000",
              resize: "none",
              "show-word-limit": "",
            },
            model: {
              value: _vm.newText,
              callback: function ($$v) {
                _vm.newText = $$v
              },
              expression: "newText",
            },
          })
        : _c("el-input", {
            attrs: {
              value: _vm.editText,
              type: "textarea",
              rows: 10,
              maxlength: "1000",
              resize: "none",
              "show-word-limit": "",
            },
            on: { input: _vm.changeEditText },
          }),
      _vm._v(" "),
      _c("OptionsButtons", {
        attrs: { "text-positive": "Save", "disabled-okay": _vm.disabledButton },
        on: { pushedPositive: _vm.saveNote },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }